import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import usePendingTransactions from '../../hooks/transactions/useCanceledTransactions';
import { loginData } from '../../stores/auth';
import { Link } from 'react-router-dom';
import './style/pendingTransactions.scss';

const CanceledTransactions = () => {
  const dataLogin = useSelector(loginData);
  const { transactions, isLoading, error } = usePendingTransactions(
    dataLogin?.data?.token
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState('');
  const [selectedOrderType, setSelectedOrderType] = useState('');

  const filteredData = React.useMemo(() => {
    return transactions.filter((transaction) => {
      const transactionId = (transaction.id || '').toString();
      const productName = (transaction.product || '').toString();
      const categoryName = (transaction.category || '').toString();
      const paymentStatusName = (transaction.paymentStatus || '').toString();
      const orderTypeName = (transaction.orderType || '').toString();

      const matchesSearch =
        transactionId.toLowerCase().includes(searchTerm.toLowerCase()) ||
        productName.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory =
        selectedCategory === '' || categoryName === selectedCategory;
      const matchesPaymentStatus =
        selectedPaymentStatus === '' ||
        paymentStatusName === selectedPaymentStatus;
      const matchesOrderType =
        selectedOrderType === '' || orderTypeName === selectedOrderType;

      return (
        matchesSearch &&
        matchesCategory &&
        matchesPaymentStatus &&
        matchesOrderType
      );
    });
  }, [transactions, searchTerm, selectedCategory, selectedPaymentStatus, selectedOrderType]);

  const data = React.useMemo(() => filteredData, [filteredData]);

  return (
    <div className="pending-transactions">
      {error && <div className="error-message">{error}</div>}

      <div className="search-section">
        <input
          type="text"
          placeholder="Search transaction id or product name"
          className="search-bar"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="filters">
        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">All Category</option>
          {[...new Set(transactions.map((t) => t.category).filter(Boolean))].map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
        <select
          value={selectedPaymentStatus}
          onChange={(e) => setSelectedPaymentStatus(e.target.value)}
        >
          <option value="">All Payment Status</option>
          {[...new Set(transactions.map((t) => t.paymentStatus).filter(Boolean))].map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </select>
        <select
          value={selectedOrderType}
          onChange={(e) => setSelectedOrderType(e.target.value)}
        >
          <option value="">All Order Type</option>
          {[...new Set(transactions.map((t) => t.orderType).filter(Boolean))].map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>

      {isLoading ? (
        <div className="loading">Loading transactions...</div>
      ) : (
        <div className="table-container">
          <table className="transactions-table">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" className="header-checkbox" />
                </th>
                <th>Transaction ID</th>
                <th>Product Name</th>
                <th>Transaction Date</th>
                <th>Order Status</th>
                <th>Payment Status</th>
                <th>Category</th>
                <th>Order Type</th>
                <th>Total Transaction</th>
                <th>Shipping By</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      <input type="checkbox" className="row-checkbox" />
                    </td>
                    <td>
                      <Link to={`/transactions/canceled/${row.id}`} className="link-detail">
                        {row.id}
                      </Link>
                    </td>
                    <td>
                      <div className="product-cell">
                        <img src={row.image} alt="product" className="product-image" />
                        <span>{row.product}</span>
                      </div>
                    </td>
                    <td>{row.date}</td>
                    <td>{row.orderStatus}</td>
                    <td>{row.paymentStatus}</td>
                    <td>{row.category}</td>
                    <td>{row.orderType}</td>
                    <td>{row.total}</td>
                    <td>{row.shipping}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10} style={{ textAlign: 'center', padding: '20px' }}>
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CanceledTransactions;
